import Kieth from "../../../../images/avatar/c-sm.jpg";
import Carr from "../../../../images/avatar/d-sm.jpg";

export const activityData = [
  {
    img: Kieth,
    initial: "KJ",
    theme: "success",
    name: "Kieth Jensen",
    activity: "requested to Withdrawal",
    time: "2 hours ago",
  },
  {
    img: null,
    initial: "HS",
    theme: "warning",
    name: "Harry Simpson",
    activity: "placed a Order",
    time: "2 hours ago",
  },
  {
    img: null,
    initial: "SM",
    theme: "azure",
    name: "Stephenie Marshall",
    activity: "got a huge bonus",
    time: "2 hours ago",
  },
  {
    img: Carr,
    initial: "NC",
    theme: "purple",
    name: "Nicolas Carr",
    activity: "deposited funds",
    time: "2 hours ago",
  },
  {
    img: null,
    initial: "TM",
    theme: "pink",
    name: "Timothy Moreno",
    activity: "placed a Order",
    time: "2 hours ago",
  },
];
